import { addExportVisitor$, addImportVisitor$, realmPlugin } from "@mdxeditor/editor";
import { $createListItemNode, $createListNode, $isListItemNode, $isListNode, ListNode } from "@lexical/list";

/**
 * MDXEditor's list visitors drop an ordered list's start number, so a line such as
 * `21. september 2026` (which markdown reads as a list starting at 21) is saved as
 * `1. september 2026`. These visitors carry the start number through import and export.
 */
export const listStartPlugin = realmPlugin({
    init(realm) {
        realm.pubIn({
            [addImportVisitor$]: {
                priority: 10,
                testNode: "list",
                visitNode: ({ mdastNode, lexicalParent, actions }: any) => {
                    const listType = mdastNode.children.some((e: any) => typeof e.checked === "boolean")
                        ? "check"
                        : mdastNode.ordered ? "number" : "bullet";
                    const lexicalNode = $createListNode(listType, mdastNode.ordered ? mdastNode.start ?? 1 : 1);
                    if ($isListItemNode(lexicalParent)) {
                        const dedicatedParent = $createListItemNode();
                        dedicatedParent.append(lexicalNode);
                        lexicalParent.insertAfter(dedicatedParent);
                    } else {
                        lexicalParent.append(lexicalNode);
                    }
                    actions.visitChildren(mdastNode, lexicalNode);
                },
            },
            [addExportVisitor$]: {
                priority: 10,
                testLexicalNode: $isListNode,
                visitLexicalNode: ({ lexicalNode, actions }: any) => {
                    const ordered = (lexicalNode as ListNode).getListType() === "number";
                    actions.addAndStepInto("list", {
                        ordered,
                        start: ordered ? (lexicalNode as ListNode).getStart() : undefined,
                        spread: false,
                    });
                },
            },
        });
    },
});
